'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _effects = require('redux-saga/effects');

var _legalBriefs = require('../actions/legalBriefs');

var _api = require('../api');

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchLegalBriefs),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchLegalBrief),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(editLegalBrief),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(createLegalBrief),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(deleteLegalBrief),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(fetchLegalBriefsRequest),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(fetchLegalBriefRequest),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(editLegalBriefRequest),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(createLegalBriefRequest),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(deleteLegalBriefRequest);

function fetchLegalBriefs(_ref) {
    var filter = _ref.filter;
    var disciplineId, response;
    return regeneratorRuntime.wrap(function fetchLegalBriefs$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.prev = 0;
                    disciplineId = filter.disciplineId;
                    _context.next = 4;
                    return (0, _effects.call)(_api.request, 'get', '/legalbriefs?disciplines=' + disciplineId);

                case 4:
                    response = _context.sent;
                    _context.next = 7;
                    return (0, _effects.put)(_legalBriefs.actionCreators.fetchLegalBriefsSucceeded(response.data, filter));

                case 7:
                    _context.next = 13;
                    break;

                case 9:
                    _context.prev = 9;
                    _context.t0 = _context['catch'](0);
                    _context.next = 13;
                    return (0, _effects.put)(_legalBriefs.actionCreators.fetchLegalBriefsFailed('Ocorreu um erro na busca de assuntos'));

                case 13:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[0, 9]]);
}

function fetchLegalBrief(_ref2) {
    var legalBriefId = _ref2.legalBriefId;
    var response;
    return regeneratorRuntime.wrap(function fetchLegalBrief$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/legalbriefs/' + legalBriefId);

                case 3:
                    response = _context2.sent;
                    _context2.next = 6;
                    return (0, _effects.put)(_legalBriefs.actionCreators.fetchLegalBriefSucceeded(response.data));

                case 6:
                    _context2.next = 12;
                    break;

                case 8:
                    _context2.prev = 8;
                    _context2.t0 = _context2['catch'](0);
                    _context2.next = 12;
                    return (0, _effects.put)(_legalBriefs.actionCreators.fetchLegalBriefFailed());

                case 12:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this, [[0, 8]]);
}

function editLegalBrief(_ref3) {
    var legalBriefId = _ref3.legalBriefId,
        changes = _ref3.changes,
        redirect = _ref3.redirect;
    return regeneratorRuntime.wrap(function editLegalBrief$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.prev = 0;
                    _context3.next = 3;
                    return (0, _effects.call)(_api.request, 'put', '/legalbriefs/' + legalBriefId, changes);

                case 3:
                    _context3.next = 5;
                    return (0, _effects.put)(_legalBriefs.actionCreators.editLegalBriefSucceeded());

                case 5:
                    if (!redirect) {
                        _context3.next = 8;
                        break;
                    }

                    _context3.next = 8;
                    return (0, _effects.call)(redirect);

                case 8:
                    _context3.next = 14;
                    break;

                case 10:
                    _context3.prev = 10;
                    _context3.t0 = _context3['catch'](0);
                    _context3.next = 14;
                    return (0, _effects.put)(_legalBriefs.actionCreators.editLegalBriefFailed());

                case 14:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this, [[0, 10]]);
}

function createLegalBrief(_ref4) {
    var legalBrief = _ref4.legalBrief,
        redirect = _ref4.redirect;
    return regeneratorRuntime.wrap(function createLegalBrief$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.prev = 0;
                    _context4.next = 3;
                    return (0, _effects.call)(_api.request, 'post', '/legalbriefs/', legalBrief);

                case 3:
                    _context4.next = 5;
                    return (0, _effects.put)(_legalBriefs.actionCreators.createLegalBriefSucceeded());

                case 5:
                    if (!redirect) {
                        _context4.next = 8;
                        break;
                    }

                    _context4.next = 8;
                    return (0, _effects.call)(redirect);

                case 8:
                    _context4.next = 14;
                    break;

                case 10:
                    _context4.prev = 10;
                    _context4.t0 = _context4['catch'](0);
                    _context4.next = 14;
                    return (0, _effects.put)(_legalBriefs.actionCreators.createLegalBriefFailed());

                case 14:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this, [[0, 10]]);
}

function deleteLegalBrief(_ref5) {
    var legalBriefId = _ref5.legalBriefId,
        filter = _ref5.filter;
    var response;
    return regeneratorRuntime.wrap(function deleteLegalBrief$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.prev = 0;
                    _context5.next = 3;
                    return (0, _effects.call)(_api.request, 'DELETE', '/legalbriefs/' + legalBriefId);

                case 3:
                    response = _context5.sent;

                    if (!response.data.success) {
                        _context5.next = 11;
                        break;
                    }

                    _context5.next = 7;
                    return (0, _effects.put)(_legalBriefs.actionCreators.deleteLegalBriefSucceeded());

                case 7:
                    _context5.next = 9;
                    return (0, _effects.put)(_legalBriefs.actionCreators.fetchLegalBriefsRequest(filter));

                case 9:
                    _context5.next = 13;
                    break;

                case 11:
                    _context5.next = 13;
                    return (0, _effects.put)(_legalBriefs.actionCreators.deleteLegalBriefFailed());

                case 13:
                    _context5.next = 19;
                    break;

                case 15:
                    _context5.prev = 15;
                    _context5.t0 = _context5['catch'](0);
                    _context5.next = 19;
                    return (0, _effects.put)(_legalBriefs.actionCreators.deleteLegalBriefFailed(_context5.t0));

                case 19:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this, [[0, 15]]);
}

function fetchLegalBriefsRequest() {
    return regeneratorRuntime.wrap(function fetchLegalBriefsRequest$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(_legalBriefs.actionTypes.FETCH_LEGAL_BRIEFS_REQUEST, fetchLegalBriefs);

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function fetchLegalBriefRequest() {
    return regeneratorRuntime.wrap(function fetchLegalBriefRequest$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return (0, _effects.takeLatest)(_legalBriefs.actionTypes.FETCH_LEGAL_BRIEF_REQUEST, fetchLegalBrief);

                case 2:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function editLegalBriefRequest() {
    return regeneratorRuntime.wrap(function editLegalBriefRequest$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return (0, _effects.takeLatest)(_legalBriefs.actionTypes.EDIT_LEGAL_BRIEF_REQUEST, editLegalBrief);

                case 2:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

function createLegalBriefRequest() {
    return regeneratorRuntime.wrap(function createLegalBriefRequest$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    _context9.next = 2;
                    return (0, _effects.takeLatest)(_legalBriefs.actionTypes.CREATE_LEGAL_BRIEF_REQUEST, createLegalBrief);

                case 2:
                case 'end':
                    return _context9.stop();
            }
        }
    }, _marked9, this);
}

function deleteLegalBriefRequest() {
    return regeneratorRuntime.wrap(function deleteLegalBriefRequest$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    _context10.next = 2;
                    return (0, _effects.takeLatest)(_legalBriefs.actionTypes.DELETE_LEGAL_BRIEF_REQUEST, deleteLegalBrief);

                case 2:
                case 'end':
                    return _context10.stop();
            }
        }
    }, _marked10, this);
}

exports.default = [createLegalBriefRequest, deleteLegalBriefRequest, fetchLegalBriefsRequest, fetchLegalBriefRequest, editLegalBriefRequest];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/effects/legalBriefs.js
// module id = 2237
// module chunks = 0